import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Layout from '../components/Layout';

import Menu from '../pages/Menus/Menu';

import AddMenuItem from '../pages/MenuItems/AddMenuItem';
import MenuItem from '../pages/MenuItems/MenuItem';

import Attributes from '../pages/Attributes';

import Categories from '../pages/Categories';

import Tables from '../pages/Tables';
import AddTable from '../pages/Tables/AddTable';
import Table from '../pages/Tables/Table';

import Venues from '../pages/Venues';

import Devices from '../pages/Devices';
import AddDevice from '../pages/Devices/AddDevice';
import EditDevice from '../pages/Devices/EditDevice';

import Qrcodes from '../pages/Qrcodes';
import AddQrcode from '../pages/Qrcodes/AddQrcode';

import Orders from '../pages/Orders';
import Order from '../pages/Orders/Order';
import OrdersLive from '../pages/OrdersLive';
import OrdersTakeaway from '../pages/OrdersTakeaway';

import LogoUpCo from '../components/LogoUpCo';
import VenueWatcher from '../components/VenueWatcher';
import useRoles from '../hooks/useRoles';
// import Admin from '../pages/Admin';
import ModifierAttributes from '../pages/Attributes/ModifierAttributes';
import CreateCampaign from '../pages/CreateCampaign';
import CustomerReviews from '../pages/CustomerReviews';
import AddPrinter from '../pages/Devices/AddPrinter';
import EditPrinter from '../pages/Devices/EditPrinter';
import Discounts from '../pages/Discounts';
import Discount from '../pages/Discounts/Discount';
import DiscountAddItem from '../pages/Discounts/DiscountAddItem';
import Home from '../pages/Home';
import Images from '../pages/Images';
import ItemTabs from '../pages/ItemTabs';
import Locked, { LOCKTYPES } from '../pages/Locked';
import Mobiles from '../pages/Mobiles';
import EditMobile from '../pages/Mobiles/EditMobile';
import Payouts from '../pages/Payouts';
import Personalisation from '../pages/Personalisation';
import PromoCodes from '../pages/PromoCodes';
import Promotions from '../pages/Promotions';
import Promotion from '../pages/Promotions/Promotion';
import ReportCustomers from '../pages/ReportCustomers';
import ReportOverview from '../pages/ReportOverview';
import ReportSales from '../pages/ReportSales';
import ReportStaff from '../pages/ReportStaff';
import SalesAreas from '../pages/SalesAreas';
import SalesArea from '../pages/SalesAreas/SalesArea';
import Settings from '../pages/Settings';
import BusinessDetails from '../pages/Settings/Business/BusinessDetails';
import ReportEmails from '../pages/Settings/Business/ReportEmails';
import Team from '../pages/Settings/Team';
import AdditionalChargeSettings from '../pages/Settings/Venue/AdditionalCharge';
import Courses from '../pages/Settings/Venue/Courses';
import OpeningHours from '../pages/Settings/Venue/OpeningHours';
import ServiceChargeSettings from '../pages/Settings/Venue/ServiceCharge';
import ServiceStatus from '../pages/Settings/Venue/ServiceStatus';
import UpsellsSettings from '../pages/Settings/Venue/UpsellsSettings';
import VenueDetails from '../pages/Settings/Venue/VenueDetails';
import VoucherSettings from '../pages/Settings/Venue/VoucherSettings';
import Staff from '../pages/Staff';
import AddStaff from '../pages/Staff/AddStaff';
import EditStaff from '../pages/Staff/EditStaff';
import AddMultipleTables from '../pages/Tables/AddMultipleTables';
import Tabs from '../pages/Tabs';
import Tab from '../pages/Tabs/Tab';
import Tills from '../pages/Tills';
import UpsellsPage from '../pages/Upsells';
import ItemUpsells from '../pages/Upsells/ItemUpsells';
// import VenueFees from '../pages/VenueFees';
import VoucherTabs from '../pages/VoucherTabs';
import Voucher from '../pages/Vouchers/Voucher';
import ROLES from '../shared/constants/roles';
import { getFirstLogin } from '../store/signup/firstLogin';
import { fetchVenue, fetchVenues } from '../store/venues';
import {
  getVenueState,
  getVenuesState,
  isDeliveryOnly,
  isPro,
  isStandard,
} from '../store/venues/selectors';
// import Shop from '../pages/Shop';
import ActiveVenueWatcher from '../components/ActiveVenueWatcher';
import DeliveryReports from '../components/DeliveryReports';
import useEventTracker from '../hooks/useEventTracker';
import useSwitchVenue from '../hooks/useSwitchVenue';
import Accounts from '../pages/Accounts';
import AccountOrders from '../pages/Accounts/AccountOrders';
// import Adjustment from '../pages/Adjustments/Adjustment';
// import CreateAdjustment from '../pages/Adjustments/Adjustment/CreateAdjustment';
// import DeliveryAdjustments from '../pages/Adjustments/Delivery';
// import BrandSettings from '../pages/BrandSettings';
// import BrandsItems from '../pages/Brands/BrandItems';
// import BrandsModifierAttributes from '../pages/Brands/BrandsAttributes/BrandsModifierAttributes';
// import BrandsIngredientsList from '../pages/Brands/BrandsIngredientsList';
// import BrandsMenu from '../pages/Brands/BrandsMenu';
// import AddBrandsMenuItem from '../pages/Brands/BrandsMenuItems/AddMenuItem';
// import BrandsMenuItem from '../pages/Brands/BrandsMenuItems/BrandsMenuItem';
// import BrandsMenuManagement from '../pages/Brands/BrandsMenuManagement';
// import CustomerSettings from '../pages/CustomerSettings';
import DeliveryStatements from '../pages/DeliveryStatements';
import Invoices from '../pages/Invoices';
import Kiosks from '../pages/Kiosks';
import Menus from '../pages/Menus';
import Payout from '../pages/Payout';
import PlatformInvoices from '../pages/PlatformInvoices';
import ReportDelivery from '../pages/ReportDelivery';
import SessionsScore from '../pages/SessionsScore';
import StripeAccountContainer from '../pages/Settings/Business/StripeAccountContainer';
import DeliveryOpeningHours from '../pages/Settings/Venue/DeliveryOpeningHours';
import TabPayment from '../pages/Tabs/TabPayment';
import CashUpDetails from '../pages/Tills/CashUpDetails';
import AddCustomUpsellGroupForm from '../pages/Upsells/AddCustomUpsellGroupForm';
import CheckoutUpsellGroup from '../pages/Upsells/CheckoutUpsellGroup';
import EditCustomUpsellGroup from '../pages/Upsells/EditCustomUpsellGroup';
import updateGtmDataLayer from '../shared/utils/updateGtmDataLayer';
// import Churn from '../pages/Churn';
// import DeliveryPromotions from '../pages/DeliveryPromotions';
import { logout } from '../store/session';

const ConditionalRoute = ({
  path,
  children,
  title,
  blockStandard,
  blockDeliveryOnly,
  isOnlyDelivery,
  accessrole,
}) => {
  const typeStandard = useSelector(isStandard);
  const typeDeliveryOnly = useSelector(isDeliveryOnly);
  const typePro = useSelector(isPro);
  const { isAdmin, isRoleAtLeast } = useRoles();

  const showStandardLockedPage = !isAdmin() && typeStandard && blockStandard;
  const showDeliveryOnlyLockedPage = !isAdmin() && typeDeliveryOnly && blockDeliveryOnly;
  const showNotDeliveryOnlyLockedPage = isOnlyDelivery ? !typeDeliveryOnly : false;
  const blockUnknwonVenueType =
    !isAdmin() && !typeStandard && !typePro && !typeDeliveryOnly && path !== '/home';
  const showRoleLockedPage = accessrole && !isRoleAtLeast(accessrole);
  const type = (blockStandard && LOCKTYPES.STANDARD) || LOCKTYPES.ROLE;

  if (
    !blockUnknwonVenueType &&
    !showRoleLockedPage &&
    !showStandardLockedPage &&
    !showDeliveryOnlyLockedPage &&
    !showNotDeliveryOnlyLockedPage
  ) {
    return <Route path={path}>{children}</Route>;
  }
  return (
    <Route path={path}>
      <Locked title={title} type={type} />
    </Route>
  );
};

const AuthenticatedApp = () => {
  const dispatch = useDispatch();
  const { loading: loadingVenues, data: venues } = useSelector(getVenuesState);
  const { loading: loadingVenue, data: venue } = useSelector(getVenueState);
  const { data: appState } = useSelector((state) => state.app.session);
  const { username } = appState || {};
  const [defaultPath, setDefaultPath] = useState('/home');
  const [finalVenueState, setFinalVenueState] = useState(null);
  const [previousLocation, setPreviousLocation] = useState(null);
  const { isAdmin, isRoleAtLeast } = useRoles();
  const location = useLocation();
  const switchVenue = useSwitchVenue();
  const trackEvent = useEventTracker();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const venueId = queryParams.get('venueId');

    if (venueId) {
      switchVenue(venueId);
      if (finalVenueState) {
        trackEvent(username, 'venueDetails', finalVenueState.venueId, finalVenueState);
      }
    }
  }, [finalVenueState, location.search, switchVenue, trackEvent, username]);

  useEffect(() => {
    const firstFetch = async () => {
      await dispatch(fetchVenues());
      const venueState = await dispatch(fetchVenue());
      setFinalVenueState(venueState);
    };
    if (!venues && !loadingVenues) firstFetch();
  }, [dispatch, loadingVenues, venues]);

  useEffect(() => {
    if (!getFirstLogin()) setDefaultPath('/home');
    if (venue && appState && appState.username) {
      updateGtmDataLayer({ userId: appState.username, venueId: venue.venueId });
    }
  }, [appState, venue, venues]);

  useEffect(() => {
    setPreviousLocation(location);
  }, [location]);

  useEffect(() => {
    if (previousLocation?.pathname.includes('/callback')) {
      if (!localStorage.getItem('hasLoggedGroup') && finalVenueState) {
        trackEvent(username, 'venueDetails', finalVenueState.venueId, finalVenueState);
        localStorage.setItem('has_logged_group', 'true');
      }
    }
  }, [finalVenueState, previousLocation, trackEvent, username]);

  // Array of venue IDs that should NOT redirect to new dashboard
  const allowedVenueIds = [
    'd45bae43-3074-461a-bc69-19dbbfed3351',
    '385b6471-99b8-408e-94fb-4d1c40fc25e6',
    'ff27315f-14f7-4b57-bbf1-9e1ed69faabb',
    '4b78af9d-eb7b-46ee-bf40-e8a169101ece',
    'd0b7d71a-2171-4fca-8a29-d5f66327cc18',
    'b9c19ca8-e4d8-4dc3-9058-125685dd8ed7',
    'ae6db2d4-fd32-44e0-97af-5861342af455',
    'eabdbdf0-916a-4c58-888b-0499f7f3872c',
    'ca7a56ea-4f54-4da2-a0bc-3e4a1f50e6eb',
    '35d6eba5-6d3f-4ef8-9446-500d054b294f',
    'a8fa3138-521b-4167-a500-2cdead967982',
    '9edb1827-f6b6-471d-bb9c-19fb02835221',
    'a8c53e68-a56f-40f6-82b1-9b41593185f8',
    '8aa63b8b-ccbf-4dce-9443-c048275010b8',
    'e109059b-3243-428b-83d7-d4b51dbcf580',
    'bafbfc11-e516-4476-84f5-6e3973ee5d80',
    'b85e703b-f0de-4b0c-a0af-8a4acdccbbcb',
    '8ec648cb-5c7f-44fc-a4ec-a23c6e1af193',
    '2ba78f82-0f57-47d6-9e19-23bace9407f3',
    '8e3879a3-e585-4590-9899-d836de62cec2',
    '3cfa4fb9-c8ec-4483-98ab-d2f24b005ac0',
    '6e4d45ff-9132-4129-8029-5996d2eda2d9',
    '6d7044d7-52c5-4d36-a233-dd27dde65102',
    '8e3879a3-e585-4590-9899-d836de62cec2',
    '073874b9-34b1-4c4c-a63b-c4d4f857c477',
    '50a3d287-cced-4280-9963-dc21c058a4a7',
    '31d215ae-d685-4014-9537-9212c9feaba7',
    '7a00b402-4100-4bc4-941b-74c983c0321f',
  ];

  if (
    finalVenueState &&
    !isRoleAtLeast(ROLES.ADMIN) &&
    !allowedVenueIds.includes(finalVenueState.venueId)
  ) {
    dispatch(logout());
    window.location.href = `${process.env.REACT_APP_BETA_URI}`;
  }

  if (loadingVenues || loadingVenue) {
    return <LogoUpCo />;
  }

  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
  });

  return (
    <Layout>
      <>
        <VenueWatcher />
        {!isAdmin() && <ActiveVenueWatcher />}
        {venues && venue && (
          <Switch>
            <ConditionalRoute path="/home" title="Home">
              <Home />
            </ConditionalRoute>
            {/* <ConditionalRoute
              path="/admin/plan-settings/customer"
              title="Customer Stripe details"
              accessrole={ROLES.ADMIN}
            >
              <CustomerSettings />
            </ConditionalRoute> */}
            {/* <ConditionalRoute path="/admin/venue-fees" title="Venue fees" accessrole={ROLES.ADMIN}>
              <VenueFees />
            </ConditionalRoute> */}
            {/* <ConditionalRoute path="/admin/churn" title="Churn" accessrole={ROLES.SUPERADMIN}>
              <Churn />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              path="/admin/delivery-adjustments/create"
              title="Delivery adjustments"
              accessrole={ROLES.ADMIN}
            >
              <CreateAdjustment />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              path="/admin/delivery-adjustments/:adjustmentId"
              title="Delivery adjustments"
            >
              <Adjustment />
            </ConditionalRoute>
            <ConditionalRoute
              path="/admin/delivery-adjustments"
              title="Delivery adjustments"
              accessrole={ROLES.ADMIN}
            >
              <DeliveryAdjustments />
            </ConditionalRoute>
            <ConditionalRoute
              path="/admin/delivery-promotions"
              title="Delivery Promotions"
              accessrole={ROLES.ADMIN}
            >
              <DeliveryPromotions />
            </ConditionalRoute>
            <ConditionalRoute path="/admin" title="Admin" accessrole={ROLES.ADMIN}>
              <Admin />
            </ConditionalRoute> */}
            <ConditionalRoute
              path="/accounts/:accountId/orders"
              title="Orders"
              accessrole={ROLES.MANAGER}
            >
              <AccountOrders />
            </ConditionalRoute>
            <ConditionalRoute
              path="/accounts"
              title="Accounts"
              accessrole={ROLES.MANAGER}
              blockStandard
            >
              <Accounts />
            </ConditionalRoute>
            <ConditionalRoute
              path="/images"
              title="Images"
              accessrole={ROLES.ADMIN}
              blockDeliveryOnly
            >
              <Images />
            </ConditionalRoute>
            <ConditionalRoute
              path="/create-campaign"
              title="Create campaign"
              accessrole={ROLES.ADMIN}
              blockDeliveryOnly
            >
              <CreateCampaign />
            </ConditionalRoute>
            <ConditionalRoute path="/menus/:menuName" title="Menu" accessrole={ROLES.MANAGER}>
              <Menu />
            </ConditionalRoute>
            <ConditionalRoute path="/menus" title="Menu" accessrole={ROLES.MANAGER}>
              <Menus />
            </ConditionalRoute>
            <ConditionalRoute path="/categories" title="Categories" accessrole={ROLES.MANAGER}>
              <Categories />
            </ConditionalRoute>
            <ConditionalRoute
              exact
              blockStandard
              path="/offers/add"
              title="Campaign"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Promotion />
            </ConditionalRoute>
            <ConditionalRoute
              exact
              path="/offers/:campaignId"
              title="Campaign"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <Promotion />
            </ConditionalRoute>
            <ConditionalRoute
              path="/offers"
              title="Promotions"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <Promotions />
            </ConditionalRoute>
            <ConditionalRoute
              path="/discounts/promo-codes"
              title="Promo codes"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <PromoCodes />
            </ConditionalRoute>
            <ConditionalRoute
              path="/item-discounts"
              title="Item discounts"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <Discounts />
            </ConditionalRoute>
            <ConditionalRoute
              path="/item-discount/:discountId/addItems"
              title="Add items to item discount"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <DiscountAddItem />
            </ConditionalRoute>
            <ConditionalRoute
              path="/item-discount/:discountId"
              title="Discount"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <Discount />
            </ConditionalRoute>
            <ConditionalRoute
              path="/upsells/checkout-upsells"
              title="Checkout upsell groups"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <CheckoutUpsellGroup />
            </ConditionalRoute>
            <ConditionalRoute
              path="/upsells/item-upsells/upsellgroup/:upsellGroupId"
              title="Update custom upsell"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <EditCustomUpsellGroup />
            </ConditionalRoute>
            <ConditionalRoute
              path="/upsells/item-upsells/create-upsell"
              title="Create custom upsell"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <AddCustomUpsellGroupForm />
            </ConditionalRoute>
            <ConditionalRoute
              path="/upsells/item-upsells"
              title="Item upsells"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliverOnly
            >
              <ItemUpsells />
            </ConditionalRoute>
            <ConditionalRoute
              path="/upsells"
              title="Upsells"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <UpsellsPage />
            </ConditionalRoute>
            <ConditionalRoute
              path="/tables/add"
              title="Add tables"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <AddTable />
            </ConditionalRoute>
            <ConditionalRoute
              path="/tables/addMultiple"
              title="Add multiple tables"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <AddMultipleTables />
            </ConditionalRoute>
            <ConditionalRoute
              path="/tables/:tableName"
              title="Table"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Table />
            </ConditionalRoute>
            <ConditionalRoute
              path="/tables"
              title="Tables"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Tables />
            </ConditionalRoute>
            <ConditionalRoute path="/reports/weekly">
              <DeliveryReports reportType="weekly" />
            </ConditionalRoute>
            <ConditionalRoute path="/reports/daily">
              <DeliveryReports reportType="daily" />
            </ConditionalRoute>
            <ConditionalRoute
              path="/reports/staff/:tabname?"
              title="Staff Reports"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <ReportStaff />
            </ConditionalRoute>
            <ConditionalRoute
              path="/reports/sales/:tabname?"
              title="Sales Reports"
              accessrole={ROLES.MANAGER}
              blockStandard
            >
              <ReportSales />
            </ConditionalRoute>
            <ConditionalRoute
              path="/reports/customers/:tabname?"
              title="Customers Reports"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <ReportCustomers />
            </ConditionalRoute>
            <ConditionalRoute path="/reports/overview" title="Reports" accessrole={ROLES.MANAGER}>
              <ReportOverview />
            </ConditionalRoute>
            <ConditionalRoute
              path="/reports/delivery-metrics"
              title="Delivery Metrics"
              accessrole={ROLES.MANAGER}
            >
              <ReportDelivery />
            </ConditionalRoute>
            <ConditionalRoute
              path="/reports/sessions-score"
              title="Sessions Score"
              accessrole={ROLES.MANAGER}
            >
              <SessionsScore />
            </ConditionalRoute>
            <ConditionalRoute
              blockStandard
              blockDeliverOnly
              path="/menu-items/add"
              title="Add menu item"
              accessrole={ROLES.MANAGER}
            >
              <AddMenuItem />
            </ConditionalRoute>
            <ConditionalRoute
              path="/items/:tabname?/:itemId?"
              title="Items"
              accessrole={ROLES.MANAGER}
            >
              <ItemTabs />
            </ConditionalRoute>
            <ConditionalRoute
              path="/items/modifiers/:modifierId?"
              title="Items"
              accessrole={ROLES.MANAGER}
            >
              <ItemTabs />
            </ConditionalRoute>
            <ConditionalRoute
              path="/menu-items/:menuItemId/attributes"
              title="Attributes"
              accessrole={ROLES.MANAGER}
            >
              <Attributes />
            </ConditionalRoute>
            <ConditionalRoute
              path="/menu-items/:menuItemId/modifierAttributes"
              title="Modifier Attributes"
              accessrole={ROLES.MANAGER}
            >
              <ModifierAttributes />
            </ConditionalRoute>
            <ConditionalRoute
              path="/menu-items/:menuItemId"
              title="Menu item"
              accessrole={ROLES.MANAGER}
            >
              <MenuItem />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/venue-details"
              title="Venue details"
              accessrole={ROLES.OWNER}
              blockDeliveryOnly
            >
              <VenueDetails />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/opening-hours"
              title="Opening Hours"
              accessrole={ROLES.MANAGER}
              blockStandard
            >
              <OpeningHours />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/delivery-opening-hours"
              title="Delivery Opening Hours"
              accessrole={ROLES.MANAGER}
            >
              <DeliveryOpeningHours />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/service-status"
              title="Venue details"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <ServiceStatus />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/voucher-settings"
              title="Vouchers"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <VoucherSettings />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/upsells"
              title="Upsells"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <UpsellsSettings />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/service-charge"
              title="Service Charge"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <ServiceChargeSettings />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/additional-charge"
              title="Additional Charge"
              accessrole={ROLES.MANAGER}
            >
              <AdditionalChargeSettings />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/venue/courses"
              title="Courses"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <Courses />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/business/business-details"
              title="Business Details"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
              blockStandard
            >
              <BusinessDetails />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/business/payout-details"
              title="Payment Details"
              accessrole={ROLES.OWNER}
              blockStandard
            >
              <StripeAccountContainer />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/business/report-emails"
              title="Report Emails"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <ReportEmails />
            </ConditionalRoute>
            <ConditionalRoute
              path="/finance/platform-invoices"
              title="Platform Invoices"
              accessrole={ROLES.OWNER}
              blockStandard
              blockDeliveryOnly
            >
              <PlatformInvoices />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/business/delivery-statements"
              title="Delivery Statements"
              accessrole={ROLES.OWNER}
              blockStandard
            >
              <DeliveryStatements />
            </ConditionalRoute>
            <ConditionalRoute
              path="/settings/:tabname?/:subtab?"
              title="Settings"
              accessrole={ROLES.MANAGER}
            >
              <Settings />
            </ConditionalRoute>
            <ConditionalRoute
              path="/invoices/:tabname?"
              title="Invoices"
              accessrole={ROLES.MANAGER}
            >
              <Invoices />
            </ConditionalRoute>

            <ConditionalRoute
              path="/venues/personalisation"
              title="Personalisation"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Personalisation />
            </ConditionalRoute>
            <ConditionalRoute
              path="/venues/team"
              title="Team"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Team />
            </ConditionalRoute>
            <ConditionalRoute path="/venues" title="Venues">
              <Venues />
            </ConditionalRoute>
            <ConditionalRoute
              path="/devices/edit/:deviceId"
              title="Edit device"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <EditDevice />
            </ConditionalRoute>
            <ConditionalRoute
              path="/devices/add"
              title="Add device"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <AddDevice />
            </ConditionalRoute>
            <ConditionalRoute path="/devices" title="Devices" accessrole={ROLES.MANAGER}>
              <Devices />
            </ConditionalRoute>
            <ConditionalRoute
              path="/printers/add"
              title="Add printer"
              accessrole={ROLES.ADMIN}
              blockStandard
              blockDeliveryOnly
            >
              <AddPrinter />
            </ConditionalRoute>
            <ConditionalRoute
              path="/printers/edit/:printerId"
              title="Edit printer"
              accessrole={ROLES.ADMIN}
              blockStandard
              blockDeliveryOnly
            >
              <EditPrinter />
            </ConditionalRoute>
            <ConditionalRoute
              path="/mobiles/edit/:mobileDeviceId"
              title="Edit mobile"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
              blockStandard
            >
              <EditMobile />
            </ConditionalRoute>
            <ConditionalRoute
              path="/mobiles"
              title="Mobiles"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Mobiles />
            </ConditionalRoute>
            <ConditionalRoute
              path="/kiosks"
              accessrole={ROLES.MANAGER}
              title="Kiosks"
              blockDeliveryOnly
            >
              <Kiosks />
            </ConditionalRoute>
            <ConditionalRoute
              path="/staff/edit/:staffId"
              accessrole={ROLES.MANAGER}
              title="Edit staff"
              blockDeliveryOnly
            >
              <EditStaff />
            </ConditionalRoute>
            <ConditionalRoute
              path="/staff/add"
              title="Add staff"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <AddStaff />
            </ConditionalRoute>
            <ConditionalRoute
              path="/staff"
              title="Staff"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Staff />
            </ConditionalRoute>
            <ConditionalRoute path="/tabs" title="Tabs" blockDeliveryOnly>
              <Tabs />
            </ConditionalRoute>
            <ConditionalRoute path="/tab/:tabId/payment/:paymentId" title="Tab Payment">
              <TabPayment />
            </ConditionalRoute>
            <ConditionalRoute path="/tab/:tabId" title="Tab" blockDeliverOnly>
              <Tab />
            </ConditionalRoute>
            <ConditionalRoute
              path="/vouchers"
              title="Vouchers"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <VoucherTabs />
            </ConditionalRoute>
            <ConditionalRoute
              path="/vouchers/:tabname?"
              title="Vouchers"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliverOnly
            >
              <VoucherTabs />
            </ConditionalRoute>
            <ConditionalRoute
              path="/voucher/:voucherCode"
              title="Voucher"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Voucher />
            </ConditionalRoute>
            <ConditionalRoute
              path="/qrcodes/add"
              title="Add QR code"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <AddQrcode />
            </ConditionalRoute>
            <ConditionalRoute
              path="/qrcodes"
              title="QR codes"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Qrcodes />
            </ConditionalRoute>
            <ConditionalRoute
              path="/finance/payouts/:payoutId/:reportDay"
              title="Payout"
              accessrole={ROLES.OWNER}
            >
              <Payout />
            </ConditionalRoute>
            <ConditionalRoute path="/finance/payouts" title="Payouts" accessrole={ROLES.OWNER}>
              <Payouts />
            </ConditionalRoute>
            <ConditionalRoute path="/orders-live" title="Live orders">
              <OrdersLive />
            </ConditionalRoute>
            <ConditionalRoute path="/orders-takeaway" title="Takeaway orders" blockDeliveryOnly>
              <OrdersTakeaway />
            </ConditionalRoute>
            <ConditionalRoute path="/orders/:orderId" title="Order">
              <Order />
            </ConditionalRoute>
            <ConditionalRoute path="/orders-history/:backLink?" title="Orders">
              <Orders />
            </ConditionalRoute>
            <ConditionalRoute
              path="/customer-reviews"
              title="Customer reviews"
              accessrole={ROLES.MANAGER}
            >
              <CustomerReviews />
            </ConditionalRoute>
            <ConditionalRoute
              path="/sales-areas"
              title="Sales areas"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <SalesAreas />
            </ConditionalRoute>
            <ConditionalRoute
              path="/sales-area/:salesAreaId"
              title="Sales area"
              accessrole={ROLES.MANAGER}
              blockStandard
              blockDeliveryOnly
            >
              <SalesArea />{' '}
            </ConditionalRoute>

            {/* <ConditionalRoute path="/store" title="Store" accessrole={ROLES.MANAGER} > */}
            {/*   <Shop /> */}
            {/* </ConditionalRoute> */}
            <ConditionalRoute
              path="/tills/cashup/:cashupId"
              title="Cashup"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <CashUpDetails />
            </ConditionalRoute>
            <ConditionalRoute
              path="/tills"
              title="Tills"
              accessrole={ROLES.MANAGER}
              blockDeliveryOnly
            >
              <Tills />
            </ConditionalRoute>
            {/* <ConditionalRoute
              blockStandard
              blockDeliverOnly
              path="/brand-menu-management/items/add"
              title="Add brand item"
              accessrole={ROLES.ADMIN}
            >
              <AddBrandsMenuItem />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              path="/brand-menu-management/items/:tabname?/:itemId?"
              title="Brand Menu Items"
              accessrole={ROLES.ADMIN}
            >
              <BrandsItems />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              blockStandard
              blockDeliverOnly
              path="/brand-menu-management/item/:menuItemId/ingredients"
              title="Brands Ingredients"
              accessrole={ROLES.ADMIN}
            >
              <BrandsIngredientsList />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              blockStandard
              blockDeliverOnly
              path="/brand-menu-management/item/:menuItemId/modifier-attributes"
              title="Brands Modifiers"
              accessrole={ROLES.ADMIN}
            >
              <BrandsModifierAttributes />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              blockStandard
              blockDeliverOnly
              path="/brand-menu-management/item/:menuItemId"
              title="Brands Item"
              accessrole={ROLES.ADMIN}
            >
              <BrandsMenuItem />
            </ConditionalRoute> */}
            {/* <ConditionalRoute
              path="/brand-menu-management/menus/:menuId"
              title="Brands Menu"
              accessrole={ROLES.ADMIN}
            >
              <BrandsMenu />
            </ConditionalRoute>
            <ConditionalRoute
              path="/brand-menu-management/:brandId/settings"
              title="Brand Settings"
              accessrole={ROLES.ADMIN}
            >
              <BrandSettings />
            </ConditionalRoute>
            <ConditionalRoute
              path="/brand-menu-management"
              title="Brand Menu Management"
              accessrole={ROLES.ADMIN}
            >
              <BrandsMenuManagement />
            </ConditionalRoute> */}

            <Route render={() => <Redirect to={defaultPath} />} />
          </Switch>
        )}
      </>
    </Layout>
  );
};

export default AuthenticatedApp;
